import blogFilters from '../../components/blog/blog-filters';

blogFilters();
